<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img src="~@/assets/img/CITEditor/ico_bracket.png" alt="variable bracket" title="variable bracket" />
    </button>
    <div v-show="option" class="optionGroup key">
      <button type="button" class="optionItem"
        v-for="val in varList"
        :key="val"
        :class="{active: val === value}"
        @mousedown.prevent
        @click="onSelectOption($event, val)">{{val}}</button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'DataVariable',
  props: [
    'active',
    'value',
    'option'
  ],
  watch: {
    value (val) {
      if (val && val.length) {
        this.varValue = val
      }
    }
  },
  mounted () {
    // 변수처리 가능한 데이터 항목
    this.varList = this.$store.state.dataVariable
  },
  data () {
    return {
      varList: [],
      varValue: ''
    }
  },
  methods: {
    // open option:: fontsize
    onClickOption (e) {
      this.$emit('setOption', { name: 'DataVariable', state: true })
    },
    // select option
    onSelectOption (e, val) {
      e.preventDefault()
      this.varValue = this.value === val ? '' : val
      // document.execCommand('superscript', false)
      setTimeout(() => {
        this.$emit('setValue', { name: 'DataVariable', value: this.varValue })
        this.setDataVariable(this.varValue)
      })
    },
    setDataVariable (val) {
      const selection = window.getSelection()
      const spanVar = selection.focusNode.parentNode.closest(':not(sup)[data-variable]')
      if (spanVar) {
        delete spanVar.dataset.variable
      } else {
        document.execCommand('superscript', false)
        if (val) {
          selection.focusNode.parentNode.dataset.variable = val
        } else {
          delete selection.focusNode.parentNode.dataset.variable
        }
      }
    }
  }
}
</script>
